import React, { useRef } from "react";
import { Link } from "react-router-dom";
import { CTAButton } from "./UI";
import { useScrollReveal } from "../hooks";

const FACTS = [
  { num: "13", label: "Service Categories" },
  { num: "100%", label: "Client Focused" },
  { num: "End-to-End", label: "Approach" },
  { num: "1", label: "Goal: Your Growth" },
];

export default function About() {
  const ref = useRef(null);
  const visible = useScrollReveal(ref);

  return (
    <section id="about" className={"section section-border reveal-section" + (visible ? " revealed" : "")} ref={ref}>
      <div className="container">

        <div className="abt-grid">
          <div className="abt-left reveal-child" style={{ transitionDelay: "0s" }}>
            <span className="eyebrow">About OVARD</span>
            <h2 className="h2" style={{ marginTop: 16 }}>
              A digital marketing and brand growth agency built for businesses that want to grow — not just look good online.
            </h2>
            <p className="lede" style={{ marginTop: 24 }}>
              OVARD Digital is a full-service digital marketing and brand growth agency based in Mysore, Karnataka, India. We combine strategy, creative and technology to build brands that stand out, digital presences that convert, content that gets attention, and marketing that drives real growth.
            </p>
            <p className="lede" style={{ marginTop: 16 }}>
              We work with founders, growing businesses and brands across India who want a serious partner — not just another vendor.
            </p>
            <div style={{ marginTop: 40, display: "flex", gap: "16px", flexWrap: "wrap", alignItems: "center" }}>
              <CTAButton href="#contact">Work with us</CTAButton>
              <Link to="/about" className="link-inline" style={{ marginTop: 0 }}>
                Our story <span className="arr">→</span>
              </Link>
            </div>
          </div>

          <div className="abt-right reveal-child" style={{ transitionDelay: "0.18s" }}>
            {/* Image card */}
            <div className="abt-img-wrap">
              <img
                src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=900&q=80"
                alt="OVARD Digital — strategy and creative team at work"
                className="abt-img"
                loading="lazy"
              />
              <div className="abt-img-overlay">
                <div className="abt-img-badge">
                  <span className="abt-img-badge-dot" />
                  <span>Strategy · Creative · Technology</span>
                </div>
              </div>
            </div>

            {/* Facts row below image */}
            <div className="abt-facts">
              {FACTS.map((f) => (
                <div className="abt-fact" key={f.label}>
                  <span className="abt-fact-num">{f.num}</span>
                  <span className="abt-fact-label">{f.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}
